import React, { createRef } from 'react';
import { IonButton, IonInput, IonChip, IonSearchbar, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonModal, IonLoading } from '@ionic/react';
import '../styles/Statistics.scss';
import { Swiper, Slide } from 'react-dynamic-swiper'
import 'react-dynamic-swiper/lib/styles.css'
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import ReactCardFlip from 'react-card-flip';
import Utilities from '../Utilities';
import { folder, star, book, eye, pricetag, fileTrayFull, albums, close, image, checkmarkCircle, closeCircle, syncCircle, flash, flashOff, link, chevronBackCircle, chevronForwardCircle, playCircle, checkmarkDone, checkmarkDoneCircle, notifications, analytics, grid, language, expand } from 'ionicons/icons'
import Chart from './Chart';
import ChartActivity from './ChartActivity';
import BubbleUI from "react-bubble-ui";
import "react-bubble-ui/dist/index.css";
import domtoimage from 'dom-to-image';

const options = {
    size: 140,
    minSize: 20,
    gutter: 8,
    provideProps: true,
    numCols: 4,
    fringeWidth: 160,
    yRadius: 130,
    xRadius: 130,
    cornerRadius: 107,
    showGuides: false,
    compact: true,
    gravitation: 5
}

const expandedOptions = {
    ...options,
    yRadius: 200,
    xRadius: 200
}

class Statistics extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            studysetCount: 0,
            cardCount: 0,
            tagCount: 0,
            cardTypes: [],
            cardPairTypes: [],
            tagCounts: [],
            totalMistakes: 0,
            totalCorrects: 0,
            starredCount: 0,
            tagsCount: 0,
            reviewsCount: 0,
            typesCount: 0,
            imageCount: 0,
            linkCount: 0,
            activeDays: 0,
            inactiveDays: 0,
            strengths: {
                data: [],
                labels: []
            },
            completedGoal: 0,
            failedGoal: 0,
            longestStreak: 0,
            archiveCount: 0,
            langCount: 0,
            avgReviewCount: 0,
            reviewActivity: {},
            reviewCalendarDate: new Date(),
            expandedStat: null,
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open && nextProps.open) {
            this.ionViewWillEnter();
        }
    }

    async ionViewWillEnter() {
        Utilities.trackEvent("Statistics", "Statistics Page View");
        this.reloadStatistics();
    }

    reloadReviewCalendar(direction) {

        let range = direction === "back" ? Utilities.startAndEndOfMonth(Utilities.dateSub(this.state.reviewCalendarDate, "month", 1)) :
            direction === "forth" ? Utilities.startAndEndOfMonth(Utilities.dateAdd(this.state.reviewCalendarDate, "month", 1)) :
            Utilities.startAndEndOfMonth(this.state.reviewCalendarDate);

        let now = new Date(range[0]);
        let reviewCalendarData = {
            labels: [],
            data: []
        }
        let hasAnyData = false;

        while (now < Utilities.dateAdd(range[1], "day", 1)) {
            const dateHash = Utilities.formatDate(now, "YYYY-MM-DD");
            reviewCalendarData.labels.push(Utilities.formatDate(now, "DD"));
            const count = this.state.reviewActivity[dateHash] || 0;
            reviewCalendarData.data.push(count)
            if (count) {
                hasAnyData = true;
            }
            now = Utilities.dateAdd(now, "day", 1);
        }

        if (!hasAnyData) {
            reviewCalendarData.data = reviewCalendarData.data.map(item => Utilities.randomIntFromInterval(0, 119));
        }

        this.setState({
            reviewCalendarData: reviewCalendarData,
            reviewCalendarDate: range[0],
            reviewCalendarSampleData: !hasAnyData
        })
    }

    renderCalendar(labels, data, heatmapValues, dateOverride, sampleData) {

        var type = "calendar_heatmap_entries"

        if (this.props.view === "year") {
            type += "_yearly"
        }

        if (!labels) {
            labels = []
            data = []
        }

        labels = labels.map(item => parseInt(item));

        var chk = new Date();
        var chkY = chk.getFullYear();
        var chkM = chk.getMonth();
        var chkD = chk.getDate();

        let calendarMonth = (dateOverride) ? dateOverride : new Date(this.props.from);

        var y = calendarMonth.getFullYear();
        var m = calendarMonth.getMonth();
        var d = calendarMonth.getDate();
    
      var d = new Date()
      , firstDayOfMonth = new Date(y, m, 1).getDay()
      , lastDateOfMonth =  new Date(y, m+1, 0).getDate()
      , lastDayOfLastMonth = m == 0 ? new Date(y-1, 11, 0).getDate() : new Date(y, m, 0).getDate();
    
      var html = '<div class="table ' + ((type.endsWith("_yearly")) ? "year" : "") + ' ' + ((type.endsWith("_mood") || type.endsWith("_mood_yearly") || type.endsWith("_mood_weekly") ) ? "mood" : "") + (type.endsWith("goal") ? "goal" : "") + '">';

      let i=1;

      let exitCondition;

      let currentDate = new Date(calendarMonth.getFullYear(), 0, 1);
      let currentDay = 1;
      let currentMonth = 0;
      let dateHash = Utilities.formatDate(currentDate, "M-D");

        do {

            let dow

            if (type.endsWith("_yearly")) {

                if (currentDay === 1) {

                    if (currentMonth !== 0) {
                        html += "</div>"
                    } else {
                        html += `
                            <div class='row'> 
                                <div class='month-header'>J</div>
                                <div class='month-header'>F</div>
                                <div class='month-header'>M</div>
                                <div class='month-header'>A</div>
                                <div class='month-header'>M</div>
                                <div class='month-header'>J</div>
                                <div class='month-header'>J</div>
                                <div class='month-header'>A</div>
                                <div class='month-header'>S</div>
                                <div class='month-header'>O</div>
                                <div class='month-header'>N</div>
                                <div class='month-header'>D</div>
                            </div> 
                            <div class='column'> 
                                <div class='day-header'>1</div> 
                                <div class='day-header'>2</div> 
                                <div class='day-header'>3</div> 
                                <div class='day-header'>4</div> 
                                <div class='day-header'>5</div> 
                                <div class='day-header'>6</div> 
                                <div class='day-header'>7</div> 
                                <div class='day-header'>8</div> 
                                <div class='day-header'>9</div> 
                                <div class='day-header'>10</div> 
                                <div class='day-header'>11</div> 
                                <div class='day-header'>12</div> 
                                <div class='day-header'>13</div> 
                                <div class='day-header'>14</div> 
                                <div class='day-header'>15</div> 
                                <div class='day-header'>16</div> 
                                <div class='day-header'>17</div> 
                                <div class='day-header'>18</div> 
                                <div class='day-header'>19</div> 
                                <div class='day-header'>20</div> 
                                <div class='day-header'>21</div> 
                                <div class='day-header'>22</div> 
                                <div class='day-header'>23</div> 
                                <div class='day-header'>24</div> 
                                <div class='day-header'>25</div> 
                                <div class='day-header'>26</div> 
                                <div class='day-header'>27</div> 
                                <div class='day-header'>28</div> 
                                <div class='day-header'>29</div> 
                                <div class='day-header'>30</div> 
                                <div class='day-header'>31</div> 
                            </div>
                        `
                    }
                    
                    html += "<div class='column'>"

                }

            } else {

                dow = new Date(y, m, i).getDay();
        
                if ( dow == 1 ) {
                  html += '<div class="tr">';
                }
            
                else if ( i == 1 ) {

                  html += '<div class="tr">';
                  var k = lastDayOfLastMonth - firstDayOfMonth+1;
                  for(var j=1; j < firstDayOfMonth; j++) {
                    html += '<div class="td not-current">' + k + '</div>';
                    k++;
                  }
                }

            }
    
            let dayDataDOM = '<div class="entities">';
            let index = (type.endsWith("_yearly")) ? dateHash : i;

            let heatmapColors = "blue";
            let intIndex = parseInt(index);

            let heatmapIndex = 0;

            if (labels.indexOf(intIndex) !== -1) {
                let label = labels.indexOf(intIndex);
                let count = data[label];
                if (count >= heatmapValues[9]) { heatmapIndex = 9 }
                else if (count >= heatmapValues[8]) { heatmapIndex = 8 }
                else if (count >= heatmapValues[7]) { heatmapIndex = 7 }
                else if (count >= heatmapValues[6]) { heatmapIndex = 6 }
                else if (count >= heatmapValues[5]) { heatmapIndex = 5 }
                else if (count >= heatmapValues[4]) { heatmapIndex = 4 }
                else if (count >= heatmapValues[3]) { heatmapIndex = 3 }
                else if (count >= heatmapValues[2]) { heatmapIndex = 2 }
                else if (count >= heatmapValues[1]) { heatmapIndex = 1 }
                else if (count >= heatmapValues[0]) { heatmapIndex = 0 }
                dayDataDOM += `<div style="color:${count >= heatmapValues[4] ? 'white' : 'black'};background-color:${count === 0 ? ( !window.dark ? "white" : "#222" ) : window.heatmap[heatmapColors][heatmapIndex]}" >${count || ""}</div>`
            } else {
                dayDataDOM += `<div style="background-color:${( !window.dark ? "white" : "#222" )}" ></div>`
            }
    
            dayDataDOM += '</div>'
        
            html += '<div class="td normal"><div class="day-text">' + (type.endsWith("_yearly") ? currentDay : i) + '</div>' + dayDataDOM + '</div>';
        
            if ( dow == 0 ) {
              html += '</div>';
            }
        
            else if ( i == lastDateOfMonth ) {
              let k=1;
              for(dow; dow < 7; dow++) {
                html += '<div class="td not-current">' + k + '</div>';
                k++;
              }
            }
        
            i++;

            exitCondition = (i <= lastDateOfMonth);

            if (type.endsWith("_yearly")) {
                currentDate = Utilities.dateAdd(currentDate, "day", 1);
                currentDay = currentDate.getDate();
                currentMonth = currentDate.getMonth();
                dateHash = Utilities.formatDate(currentDate, "M-D")
                exitCondition = (currentDay !== 31 || currentMonth !== 11);
            }
            
            // debugger;
        
          } while (exitCondition);

          if (type.endsWith("_yearly")) {
              html += `
                </div>
                <div class='column'> 
                    <div class='day-header'>1</div> 
                    <div class='day-header'>2</div> 
                    <div class='day-header'>3</div> 
                    <div class='day-header'>4</div> 
                    <div class='day-header'>5</div> 
                    <div class='day-header'>6</div> 
                    <div class='day-header'>7</div> 
                    <div class='day-header'>8</div> 
                    <div class='day-header'>9</div> 
                    <div class='day-header'>10</div> 
                    <div class='day-header'>11</div> 
                    <div class='day-header'>12</div> 
                    <div class='day-header'>13</div> 
                    <div class='day-header'>14</div> 
                    <div class='day-header'>15</div> 
                    <div class='day-header'>16</div> 
                    <div class='day-header'>17</div> 
                    <div class='day-header'>18</div> 
                    <div class='day-header'>19</div> 
                    <div class='day-header'>20</div> 
                    <div class='day-header'>21</div> 
                    <div class='day-header'>22</div> 
                    <div class='day-header'>23</div> 
                    <div class='day-header'>24</div> 
                    <div class='day-header'>25</div> 
                    <div class='day-header'>26</div> 
                    <div class='day-header'>27</div> 
                    <div class='day-header'>28</div> 
                    <div class='day-header'>29</div> 
                    <div class='day-header'>30</div> 
                    <div class='day-header'>31</div> 
                </div>
              `
          }
    
      html += '</div>';
    
      html = '<div data-year=' + y + ' data-month=' + m + ' class="month">\
        ' + html + '\
      </div>';
    
        return html;

    }

    async reloadStatistics() {

        let studysetCount = await SQLStorage.getStudysetCount();
        let cardCount = await SQLStorage.getCardCount();
        let tagCount = await SQLStorage.getTagCount();
        let tagCounts = await SQLStorage.getTagReferencesGrouppedByTag();
        let cardTypes = await SQLStorage.getCardTypes();
        let cardPairTypes = await SQLStorage.getCardPairTypes();
        let activity = await SQLStorage.getCardsWithFields("history,image,links");

        let mistakes = 0;
        let corrects = 0;
        // let practiceSelect = 0;
        // let practicePronounce = 0;
        // let practiceType = 0;
        let practiceCount = 0;
        let starredCount = 0;
        let notificationReviews = 0;
        let flashcardReviews = 0;
        let practiceSelectReviews = 0;
        let practiceSpellReviews = 0;
        let practiceConnectReviews = 0;
        let firstAction = new Date();
        let now = new Date();
        let activeDays = [];
        let goalDaysCount = {};
        let reviewActivityObj = {};
        let reviewActivity = [];
        let mostReviews = 0;
        let imageCount = 0;
        let linkCount = 0;

        for (let i = 0; i < activity.length; i++) {

            imageCount += activity[i].image.length;
            linkCount += activity[i].links.length;

            let history = activity[i].history || [];

            for (let j = 0; j < history.length; j++) {

                const element = history[j].split("_");
                const actionCode = element[0];
                const actionData = element[1];
                const actionDate = new Date(element[2]*1000);
                const actionDateHash = Utilities.formatDate(actionDate, "YYYY-MM-DD");

                if (firstAction > actionDate) {
                    firstAction = actionDate;
                }
    
                if (activeDays.indexOf(actionDateHash) === -1) {
                    activeDays.push(actionDateHash);
                }

                if (actionCode === "pronounce" || actionCode === "select" || actionCode === "type" || actionCode === "10" || actionCode === "11" || actionCode.indexOf("term") !== -1 || actionCode.indexOf("definition") !== -1 ) {

                    // if (actionCode === "pronounce") {
                    //     // practicePronounce++;
                    //     if (actionData === "1") { corrects++ } else { mistakes++; }
                    // } else if (actionCode === "select") {
                    //     // practiceSelect++;
                    //     if (actionData === "1") { corrects++ } else { mistakes++; }
                    // } else if (actionCode === "type") {
                    //     // practiceType++;
                    //     if (actionData === "1") { corrects++ } else { mistakes++; }
                    // } else 
                    if (actionCode === "10") {
                        notificationReviews++;
                    } else if (actionCode === "11") {
                        flashcardReviews++;
                    } else {
                        practiceCount++;
                        if (actionData === "1") { corrects++ } else { mistakes++; }

                        if (actionCode.indexOf("drag") !== -1) {
                            practiceSelectReviews++
                        } else if (actionCode.indexOf("pop") !== -1) {
                            practiceSpellReviews++
                        } else if (actionCode.indexOf("connect") !== -1) {
                            practiceConnectReviews++
                        }
                    }

                    if (window.settings.goalNumber && window.settings.goalNumber !== "0") {
                        if (!goalDaysCount[actionDateHash]) {
                            goalDaysCount[actionDateHash] = 1;
                        } else {
                            goalDaysCount[actionDateHash]++;
                        }
                    }

                    if (!reviewActivityObj[actionDateHash]) {
                        reviewActivityObj[actionDateHash] = 0;
                    }

                    reviewActivityObj[actionDateHash]++;

                    if (reviewActivityObj[actionDateHash] > mostReviews) {
                        mostReviews = reviewActivityObj[actionDateHash];
                    }

                }

            }

        }

        let completedGoal = 0;
        let failedGoal = 0;
        let longestStreak = 0;

        if (window.settings.goalNumber && window.settings.goalNumber !== "0") {
            let from = new Date(firstAction);
            let goalNumber = parseInt(window.settings.goalNumber);
            let currentStreak = 0;
            while (from < now) {
                const DATE_HASH = Utilities.formatDate(from, "YYYY-MM-DD");
                if (goalDaysCount[DATE_HASH] && goalDaysCount[DATE_HASH] >= goalNumber) {
                    completedGoal++;
                    currentStreak++;
                } else {
                    failedGoal++;
                    if (currentStreak > longestStreak) {
                        longestStreak = currentStreak;
                    }
                    currentStreak = 0;
                }
                from = Utilities.dateAdd(from, "day", 1);
            }
        }

        let totalDaysInUse = Utilities.getDatesBetween(firstAction, now);

        let strengths = {
            data: [0, 0, 0, 0],
            labels: [window.ln.new, window.ln.studying, window.ln.learnt, window.ln.mastered]
        }

        for (let i = 0; i < tagCounts.length; i++) {
            if (tagCounts[i].tagName === "star") {
                starredCount = tagCounts[i].count;
                tagCounts.splice(i, 1);
                i--;
            } else if (["mastered", "learnt", "studying", "new", "image", "recording"].indexOf(tagCounts[i].tagName) !== -1) {
                if (tagCounts[i].tagName === "new") { strengths.data[0] = tagCounts[i].count }
                else if (tagCounts[i].tagName === "studying") { strengths.data[1] = tagCounts[i].count }
                else if (tagCounts[i].tagName === "learnt") { strengths.data[2] = tagCounts[i].count }
                else if (tagCounts[i].tagName === "mastered") { strengths.data[3] = tagCounts[i].count }
                tagCounts.splice(i, 1);
                i--;
            }
        }

        let cardTypesLength = cardTypes.length;

        for (let i = 0; i < window.globalVars.allLanguages.length; i++) {
            const language = window.globalVars.allLanguages[i];
            if (!cardTypes.find(item => item.name === language)) {
                cardTypes.push({ name: language, count: 0, skipIfDummy: true });
            }
        }

        for (let i = 0; i < cardTypes.length; i++) {
            let typeLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, cardTypes[i].name);
            let termCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode].logo : "";
            let termCountryColor = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode].color : ""
            if (window.globalVars.AVAILABLE_FLAGS.indexOf(termCountryCode) === -1) {
                termCountryCode = "gb";
                termCountryColor = "#333";
                if (cardTypes[i].skipIfDummy) {
                    cardTypes.splice(i, 1);
                    i--;
                    continue;
                }
            }
            cardTypes[i].flag = termCountryCode;
            cardTypes[i].color = termCountryColor;
        }

        for (let i = 0; i < cardPairTypes.length; i++) {
            const term = cardPairTypes[i].name.split("£££")[0];
            const def = cardPairTypes[i].name.split("£££")[1];

            for (let j = i + 1; j < cardPairTypes.length; j++) {
                const term2 = cardPairTypes[j].name.split("£££")[0];
                const def2 = cardPairTypes[j].name.split("£££")[1];

                if (term2 === def && term === def2) {
                    cardPairTypes[i].count += cardPairTypes[j].count;
                    cardPairTypes.splice(j, 1);
                    j--;
                }
            }
        }

        for (let i = 0; i < cardPairTypes.length; i++) {
            const term = cardPairTypes[i].name.split("£££")[0]
            let typeLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, term);
            let termCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode].logo : "";
            let termCountryColor = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[typeLangCode].color : ""

            const def = cardPairTypes[i].name.split("£££")[1]
            let defTypeLangCode = Utilities.getKeyByValue(window.globalVars.LANGUAGE_CODES, def);
            let defCountryCode = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[defTypeLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[defTypeLangCode].logo : "";
            let defCountryColor = window.globalVars.LANGUAGES_CODES_TO_COUNTRY[defTypeLangCode] ? window.globalVars.LANGUAGES_CODES_TO_COUNTRY[defTypeLangCode].color : ""
            
            if (window.globalVars.AVAILABLE_FLAGS.indexOf(termCountryCode) === -1) {
                termCountryCode = "gb";
                termCountryColor = "#333";
            }

            if (window.globalVars.AVAILABLE_FLAGS.indexOf(defCountryCode) === -1) {
                defCountryCode = "gb";
                defCountryColor = "#333";
            }

            cardPairTypes[i].flag = termCountryCode;
            cardPairTypes[i].color = termCountryColor;
            cardPairTypes[i].flag2 = defCountryCode;
            cardPairTypes[i].color2 = defCountryColor;
        }

        console.log(tagCount, "<<<<<<<<<<<<<<<<<,")

        this.setState({
            studysetCount: studysetCount,
            tagCount: tagCount,
            cardCount: cardCount,
            cardTypes: cardTypes,
            cardPairTypes: cardPairTypes,
            starredCount: starredCount,
            imageCount: imageCount,
            linkCount: linkCount,

            activeDays: activeDays.length,
            inactiveDays: totalDaysInUse.length - activeDays.length,
            
            completedGoal: completedGoal,
            failedGoal: failedGoal,
            longestStreak: longestStreak,
            
            totalMistakes: mistakes,
            totalCorrects: corrects,
            // practiceSelect: practiceSelect,
            // practicePronounce: practicePronounce,
            // practiceType: practiceType,

            practiceSelectReviews: practiceSelectReviews,
            practiceSpellReviews: practiceSpellReviews,
            practiceConnectReviews: practiceConnectReviews,

            practiceCount: practiceCount,

            notificationReviews: notificationReviews,
            flashcardReviews: flashcardReviews,

            tagCounts: tagCounts,
            tagsCount: tagCounts.length,
            reviewsCount: /* practiceType + practicePronounce + practiceSelect */ + notificationReviews + flashcardReviews + practiceCount,
            typesCount: cardTypesLength,

            strengths: strengths,
            reviewActivity: reviewActivityObj,
            reviewCalendarDate: new Date(),
            // archivedCount: archivedCount
        }, () => {
            this.reloadReviewCalendar()
        })

    }

    share(id) {
        var node = document.querySelector('.bubbles-wrapper[data-bubble="' + id + '"]');
 
        if (node) {
            domtoimage.toPng(node)
            .then(function (dataUrl) {
 
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
        }
    }

    render() {
        return (
            <IonPage data-page="statistics">
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>{window.ln.stats}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>
                    <div 
                        className="statistics-wrapper"
                        style={{
                            visibility: (this.state.reviewCalendarData && this.state.cardTypes) ? "visible" : "hidden"
                        }}
                    >
                        {/* { (Object.keys(this.state.reviewActivity).length !== 0) &&
                            <ChartActivity
                                values={this.state.reviewActivity}
                                title={window.ln.reviewGraphChart}
                            />
                        } */}
                        { (this.state.reviewCalendarData) &&
                            <div className='calendar-wrapper'>
                                { (this.state.reviewCalendarSampleData) &&
                                    <div className="sample-data">{(window.ln.sampleData)}</div>
                                }
                                <div className='header'>
                                    <h2>{window.ln.reviewFreq}</h2>
                                    <div className='date-paginator'>
                                        <IonIcon icon={chevronBackCircle} onClick={() => { this.reloadReviewCalendar("back") }} />
                                        <label>{Utilities.formatDate(this.state.reviewCalendarDate, "MMM YYYY")}</label>
                                        <IonIcon icon={chevronForwardCircle} onClick={() => { this.reloadReviewCalendar("forth") }} />
                                    </div>
                                </div>
                                <div className="calendar" dangerouslySetInnerHTML={{__html: this.renderCalendar(this.state.reviewCalendarData.labels, this.state.reviewCalendarData.data, [10, 20, 30, 40, 50, 60, 70, 80, 90, 100], new Date(this.state.reviewCalendarDate), this.state.reviewCalendarSampleData)}} />
                            </div>
                        }
                        <div 
                            className='bubbles-wrapper'
                            data-expanded={this.state.expandedStat === "1"}
                            onClick={() => { this.setState({ expandedStat: this.state.expandedStat === null ? "1" : null }) }}
                            data-bubble="1"
                        >
                            { this.state.expandedStat !== "1" &&
                                <div className='expand-btn'>
                                    <IonIcon icon={expand} />
                                </div>
                            }
                            <div className='header'>
                                <h2>{window.ln.stats}</h2>
                            </div>
                            <BubbleUI options={this.state.expandedStat === "1" ? expandedOptions : options} className="myBubbleUI">
                                { [
                                    { icon: eye, count: this.state.reviewsCount, label: window.ln.reviews, color: '#4D80E4' },
                                    { icon: checkmarkCircle, count: this.state.completedGoal, label: window.ln.dailyGoalsCompleted, color: '#2dce91' },
                                    { icon: flashOff, count: this.state.inactiveDays, label: window.ln.inactiveDays, color: '#fb3640' },
                                    { icon: syncCircle, count: this.state.longestStreak, label: window.ln.longestStreak, color: '#9852f9' },
                                    { icon: flash, count: this.state.activeDays, label: window.ln.activeDays, color: '#ffa259' },
                                    { icon: closeCircle, count: this.state.failedGoal, label: window.ln.dailyGoalsFailed, color: '#fb3640' },
                                    { icon: folder, count: this.state.studysetCount, label: window.ln.sets, color: '#4D80E4' },
                                    { icon: albums, count: this.state.cardCount, label: window.ln.cards, color: '#2dce91' },
                                    { icon: star, count: this.state.starredCount, label: window.ln.starred, color: '#f7be16' },
                                    { icon: image, count: this.state.imageCount, label: window.ln.images, color: '#9852f9' },
                                    { icon: link, count: Math.round(this.state.linkCount / 2), label: window.ln.links, color: '#ffa259' },
                                    { icon: pricetag, count: this.state.tagCount - 5, label: window.ln.tags, color: '#fc7fb2' },
                                    { icon: fileTrayFull, count: this.state.typesCount, label: window.ln.types, color: '#ffa259' },

                                    { icon: playCircle, count: this.state.strengths.data[1], label: this.state.strengths.labels[1] + " " + window.ln.cards, color: '#06D6A0' },
                                    { icon: book, count: this.state.strengths.data[0], label: this.state.strengths.labels[0] + " " + window.ln.cards, color: '#f7be16' },
                                    { icon: checkmarkCircle, count: this.state.strengths.data[2], label: this.state.strengths.labels[2] + " " + window.ln.cards, color: '#118AB2' },
                                    { icon: checkmarkDoneCircle, count: this.state.strengths.data[3], label: this.state.strengths.labels[3] + " " + window.ln.cards, color: '#7579e7' },

                                    { icon: closeCircle, count: this.state.totalMistakes, label: window.ln.mistakes, color: '#fb3640' },
                                    { icon: checkmarkCircle, count: this.state.totalCorrects, label: window.ln.corrects, color: '#2dce91' },

                                    { icon: notifications, count: this.state.notificationReviews, label: window.ln.notificationReview, color: '#ffa259' },
                                    { icon: albums, count: this.state.flashcardReviews, label: window.ln.flashcardReview, color: '#fc7fb2' },
                                    { icon: grid, count: this.state.practiceSelectReviews, label: window.ln.selectPractice, color: '#9852f9' },
                                    { icon: language, count: this.state.practiceSpellReviews, label: window.ln.spellPractice, color: '#f7be16' },
                                    { icon: analytics, count: this.state.practiceConnectReviews, label: window.ln.connectPractice, color: '#4D80E4' },
                    
                                    // XP
                                    // LEVEL
                                ].map(item => {
                                    return (
                                        <div className='bubble' style={{ background: item.color }}>
                                            <div className='content'>
                                                <IonIcon icon={item.icon} />
                                                <p>{item.label}</p>
                                                <h3>{item.count}</h3>
                                            </div>
                                        </div>
                                    )
                                }) }
                            </BubbleUI>
                        </div>

                        <div 
                            className='bubbles-wrapper'
                            data-expanded={this.state.expandedStat === "2"}
                            onClick={() => { this.setState({ expandedStat: this.state.expandedStat === null ? "2" : null }) }}
                            data-bubble="2"
                        >
                            { this.state.expandedStat !== "2" &&
                                <div className='expand-btn'>
                                    <IonIcon icon={expand} />
                                </div>
                            }
                            <div className='header'>
                                <h2>{window.ln.languages}</h2>
                            </div>
                            <BubbleUI options={this.state.expandedStat === "2" ? {...expandedOptions, numCols: 10} : {...options, numCols: 10}} className="myBubbleUI">
                                { this.state.cardTypes.map(item => {
                                    return (
                                        <div className='bubble flag' style={{ background: item.color }}>
                                            <div className='content'>
                                                <p>{item.name}</p>
                                                <h3>{item.count}</h3>
                                            </div>
                                            { (item.flag) &&
                                                <React.Fragment>
                                                    <img src={require('../images/flags/' + item.flag + '.svg')} />
                                                    <div className='shade'></div>
                                                </React.Fragment>
                                            }
                                        </div>
                                    )
                                }) }
                            </BubbleUI>
                        </div>

                        { (this.state.cardPairTypes.length !== 0) &&
                           <div 
                                className='bubbles-wrapper'
                                data-expanded={this.state.expandedStat === "3"}
                                onClick={() => { this.setState({ expandedStat: this.state.expandedStat === null ? "3" : null }) }}
                                data-bubble="3"
                            >
                                { this.state.expandedStat !== "3" &&
                                    <div className='expand-btn'>
                                        <IonIcon icon={expand} />
                                    </div>
                                }
                                <div className='header'>
                                    <h2>{window.ln.languagePairs}</h2>
                                </div>
                                <BubbleUI options={this.state.expandedStat === "3" ? {...expandedOptions, numCols: 10} : {...options, numCols: 10}} className="myBubbleUI">
                                    { this.state.cardPairTypes.map(item => {
                                        return (
                                            <div className='bubble flag flag-double' style={{ background: item.color }}>
                                                <div className='content'>
                                                    <p>{item.name.replace("£££", " - ")}</p>
                                                    <h3>{item.count}</h3>
                                                </div>
                                                { (item.flag) &&
                                                    <React.Fragment>
                                                        <div className='flag-wrapper'>
                                                            <img src={require('../images/flags/' + item.flag + '.svg')} />
                                                        </div>
                                                        <div className='flag-wrapper right'>
                                                            <img src={require('../images/flags/' + item.flag2 + '.svg')} />
                                                        </div>
                                                        <div className='shade'></div>
                                                    </React.Fragment>
                                                }
                                            </div>
                                        )
                                    }) }
                                </BubbleUI>
                            </div>
                        }

                        { this.state.tagCounts.length !== 0 &&
                            <div 
                                className='bubbles-wrapper'
                                data-expanded={this.state.expandedStat === "4"}
                                onClick={() => { this.setState({ expandedStat: this.state.expandedStat === null ? "4" : null }) }}
                                data-bubble="4"
                            >
                                { this.state.expandedStat !== "4" &&
                                    <div className='expand-btn'>
                                        <IonIcon icon={expand} />
                                    </div>
                                }
                                <div className='header'>
                                    <h2>{window.ln.tags}</h2>
                                </div>
                                <BubbleUI options={this.state.expandedStat === "4" ? {...expandedOptions, numCols: 10} : {...options, numCols: 10}} className="myBubbleUI">
                                    { this.state.tagCounts.map(item => {
                                        const color = window.globalVars.tagColors.find(color => color.id === item.tagColor);
                                        return (
                                            <div className='bubble tag' style={{ background: color ? color.color : "#333" }}>
                                                <div className='content'>
                                                    <p>{item.tagName}</p>
                                                    <h3>{item.count}</h3>
                                                </div>
                                            </div>
                                        )
                                    }) }
                                </BubbleUI>
                            </div>
                        }
                    </div>
                </IonContent>
                <IonLoading
                    isOpen={(!this.state.reviewCalendarData || !this.state.cardTypes)}
                    message={window.ln.loading}
                    duration={5000}
                />
            </IonPage>
        );
    }

};


export default withIonLifeCycle(Statistics);
